module.exports = __webpack_public_path__ + "img/6fcdaf9e2663a21aecc7518f78ec6d1b2ebfd1ed.596faa07.png";